module.exports = ".mobile-icon {\n    font-size: 30px !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/backward-play/backward-play.component.css
// module id = ./src/app/player/backward-play/backward-play.component.css
// module chunks = main